/**
 * Who a ticket is for, as the lists show it (T-122): the linked member, else the
 * stored requester name, else the address. Null when the ticket names nobody.
 */
export const contactPersonName = (ticket) => {
    if (!ticket) return null;

    const member = ticket.member;
    const memberName = member ? [member.first_name, member.last_name].filter(Boolean).join(' ') : '';

    return memberName || ticket.requester_name || ticket.requester_email || null;
};
